module.exports = __webpack_public_path__ + "b80f63918d45958d3024512c1127a0a3.svg";